export default __webpack_public_path__ + "static/media/Text(Bid with caution).1fda59d9.svg";